var _filter, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 24.78125 3.15625 C 24.914062 3.136719 25.039062 3.160156 25.15625 3.21875 C 33.425781 10.921875 41.644531 18.546875 49.8125 26.09375 C 49.84375 26.175781 49.855469 26.257812 49.84375 26.34375 C 47.363281 26.34375 44.886719 26.34375 42.40625 26.34375 C 42.40625 33.15625 42.40625 39.96875 42.40625 46.78125 C 38.21875 46.78125 34.03125 46.78125 29.84375 46.78125 C 29.84375 41.613281 29.84375 36.449219 29.84375 31.28125 C 26.59375 31.28125 23.34375 31.28125 20.09375 31.28125 C 20.09375 36.449219 20.09375 41.613281 20.09375 46.78125 C 15.90625 46.78125 11.71875 46.78125 7.53125 46.78125 C 7.53125 39.96875 7.53125 33.15625 7.53125 26.34375 C 5.050781 26.34375 2.574219 26.34375 0.09375 26.34375 C 0.0820312 26.257812 0.09375 26.175781 0.125 26.09375 C 8.269531 18.558594 16.480469 10.953125 24.75 3.28125 C 24.777344 3.242188 24.789062 3.203125 24.78125 3.15625 Z M 24.78125 3.15625 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage1);
export default __webpack_public_path__ + "static/media/homepage1.401962903ca4b9e9554fdd351391a558.svg";
export { ForwardRef as ReactComponent };